var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBase',{class:_vm.classes,attrs:{"view-box":"0 0 384 512"}},[_c('path',{attrs:{"d":"M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zm0-384a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }